import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import classes from './ClaimDiceAnimation.module.scss';
import { ClaimDiceRiveAnimation } from './ClaimDiceRiveAnimation/ClaimDiceRiveAnimation';

function ClaimDiceAnimationComponent() {
  const { trailStore } = useStores();
  const { claimDiceAnimationState } = trailStore;

  if (!claimDiceAnimationState.enable) {
    return null;
  }

  const animationKey = `${claimDiceAnimationState.coinType}-${claimDiceAnimationState.diceAmount}`;

  return (
    <div className={classes.claimDiceAnimation}>
      <ClaimDiceRiveAnimation
        key={animationKey}
        amount={claimDiceAnimationState.diceAmount}
        input={claimDiceAnimationState.coinType === 'SC' ? 'green' : 'yellow'}
        onAnimationEnd={() => {
          claimDiceAnimationState.onAnimationEnd?.();
        }}
      />
    </div>
  );
}

export const ClaimDiceAnimation = observer(ClaimDiceAnimationComponent);
